var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7048 7L6.88591 8.01761L2.5 11.9591L7 15.9824L5.81888 17L0 11.9591L0.0099396 11.9504L0.00516246 11.9463L5.7048 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2952 7L17.1141 8.01761L21.5 11.9463L17 15.9824L18.1811 17L24 11.9591L23.9901 11.9504L23.9948 11.9463L18.2952 7Z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzA0OCA3TDYuODg1OTEgOC4wMTc2MUwyLjUgMTEuOTU5MUw3IDE1Ljk4MjRMNS44MTg4OCAxN0wwIDExLjk1OTFMMC4wMDk5Mzk2IDExLjk1MDRMMC4wMDUxNjI0NiAxMS45NDYzTDUuNzA0OCA3WiIgLz4KPHBhdGggZD0iTTE4LjI5NTIgN0wxNy4xMTQxIDguMDE3NjFMMjEuNSAxMS45NDYzTDE3IDE1Ljk4MjRMMTguMTgxMSAxN0wyNCAxMS45NTkxTDIzLjk5MDEgMTEuOTUwNEwyMy45OTQ4IDExLjk0NjNMMTguMjk1MiA3WiIgLz4KPC9zdmc+Cg==";
export { SvgCode24 as ReactComponent };